import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { CustomerBo } from '@utils/types/back-office/customer-bo.ts';
import { useTranslation } from 'react-i18next';

export const useCreateCustomerBo = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const createCustomer = async ({ data }: { data: CustomerBo }) => {
    try {
      const response = await Axios.post<CustomerBo>(
        `${POST_URL().createCustomerBo}`,
        data
      );
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        throw error;
      }
      throw new Error(t('an-error-occurred-while-creating-the-customer'));
    }
  };

  return useMutation<CustomerBo, AxiosError<BaseError>, { data: CustomerBo }>(
    createCustomer,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['customersBo']);
      },
      useErrorBoundary: false
    }
  );
};
